'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Form = require('./Form');

var _Form2 = _interopRequireDefault(_Form);

var _Row = require('./Row');

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var muiLayout = {
  form: _Form2.default,
  row: _Row2.default
};

exports.default = muiLayout;


/** WEBPACK FOOTER **
 ** ../biro-material-ui/lib/layout/index.js
 **/